module.exports = __webpack_public_path__ + "static/media/飞天电子科技有限公司视频.6e317c2.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/飞天电子科技有限公司视频.mp4
// module id = WsAb
// module chunks = 1